/**
 * Events module
 */
import {NgModule} from '@angular/core';
import {SharedModule} from '@ispm/shared/shared.module';
import {DynamicFormModule} from '@ispm/dynamic-form/dynamic-form.module';
import {EventsListComponent} from '@ispm-client/modules/events/components/event-category-list/events-list.component';
import {WidgetsModule} from '@ispm/widgets/widgets.module';
import {AggregatorModule} from '@ispm-client/modules/aggregator/aggregator.module';
import {LayoutModule} from '@ispm/layout/layout.module';
import {EventsManagerComponent} from './components/events-manager/events-manager.component';
import {EventContentViewerComponent} from './components/event-content-viewer/event-content.viewer.component';
import {StoreModule} from '@ngrx/store';
import {eventsReducer} from './store/reducers/event.reducer';
import {EventService} from '@ispm-client/modules/events/services/event.service';
import {EventContentFileViewerComponent} from './components/event-content-viewer/event-file-viewer/event-content-file-viewer.component';
import {EventDynamicFormViewerComponent} from './components/event-content-viewer/event-dynamic-form-viewer/event.dynamic-form-viewer.component';
import {AccordionModule} from 'primeng/accordion';
import {CheckboxModule} from 'primeng/checkbox';
import {FormsModule} from '@angular/forms';
import {FileModule} from '@ispm-client/modules/file-module/file.module';
import {CoreModule} from '@ispm/core/core.module';
import {EventTabComponent} from '@ispm-client/modules/events/components/event-tab-modal/event-tab.component';
import {EffectsModule} from '@ngrx/effects';
import {EventEffects} from "@ispm-client/modules/events/store/actions/event.effects";
import {EventFindingRibbonComponent} from "@ispm-client/modules/events/components/event-finding-ribbon/event-finding-ribbon.component";
import {NLPValidationWizardComponent} from "@ispm-client/modules/events/components/nlp-validation-wizard/nlp-validation-wizard.component";
import {EventValidationWizardService} from "@ispm-client/modules/events/services/event-validation-wizard.service";
import { PACSLauncherModule } from '../pacs-launcher/PACSLauncher.module';

@NgModule({
  imports: [
    SharedModule,
    CoreModule,
    DynamicFormModule,
    WidgetsModule,
    AggregatorModule,
    LayoutModule,
    FileModule,
    AccordionModule,
    CheckboxModule,
    FormsModule,
    PACSLauncherModule,
    StoreModule.forFeature('events', eventsReducer),
    EffectsModule.forFeature([EventEffects])
  ],
  declarations: [
    EventsManagerComponent,
    EventsListComponent,
    EventContentViewerComponent,
    EventContentFileViewerComponent,
    EventDynamicFormViewerComponent,
    EventTabComponent,
    EventFindingRibbonComponent,
    NLPValidationWizardComponent],
  providers: [EventService,EventValidationWizardService],
  exports: [
    EventsListComponent,
    EventsManagerComponent,
    EventContentViewerComponent,
    EventTabComponent,
    EventFindingRibbonComponent,
    NLPValidationWizardComponent,
  ]
})
export class EventsModule {
}
